import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SERVER_URL } from "../config/config";
import { boolean } from "yargs";
import ICurrentMember from "./memberInterfaceStruct";
import { StringLiteral } from "typescript";

const serverURL = SERVER_URL;

interface IState {
  [key: string]: any;
}
interface IAddress {
  Id: number;
  MemberId: number;
  FirmId: number;
  FirmName: string;
  Address1: string;
  Address2: string;
  City: string;
  County: string;
  State: string;
  Zipcode: number;
  PhoneNumber: string;
  CellPhoneNumber: string;
  FaxNumber: string;
  Email: string;
  AddressType: string;
  CreatedAt: string;
  UpdatedAt: string;
}

interface IMemberSections {
  Id: number | null;
  SectionName: string | null;
  MemberId: number | null;
}
interface IMemberTags {
  Id: number | null;
  MemberTag: string | null;
  MemberId: number | null;
}
interface IOtherStateBar {
  Id: number | null;
  MemberId: number | null;
  OtherStateBarName: string | null;
  AdmitDate: string | null;
  BarId: null;
  Status: number | null;
  CreatedAt: string | null;
  UpdatedAt: string | null;
}

export const initialCurrentMember: ICurrentMember = {
  Id: null,
  BarId: "",
  MemberTypeId: null,
  MemberCodeId: null,
  isMemberCodeActive: false,
  nextMemberCodeAvlDate: null,
  AdvanceMemberCode: null,
  AdvanceMemberCodeId: null,
  isEligibleForAdvance: false,
  Title: null,
  Esquire: null,
  FirstName: "",
  LastName: "",
  Gender: null,
  DateOfBirth: null,
  AdmitDate: null,
  Comments: null,
  IsValidSupremeCourtId: null,
  IsMediator: null,
  IsArbitrator: null,
  MediatorCertificationEndsOn: null,
  CreatedAt: null,
  UpdatedAt: null,
  MemberType: null,
  MemberCode: null,
  MemberCodeFee: null,
  AdvanceMemberCodeFee: null,
  Description: null,
  YearsAdmitted: null,
  IsCurrentYearDuePaid: null,
  IsNextYearDuePaid: null,
  LastMembershipDuePaidOn: null,
  MembershipExpiresOn: null,
  OtherStateBar: [],
  Address: [],
  MemberSections: [],
  MemberTags: [],
  PrimaryAddress: null,
  PublishedAddress: null,
  SearchId: 0,
  lastYearSections: "",
};

export const currentMemberSlice = createSlice({
  name: "currentMember",
  initialState: initialCurrentMember,
  reducers: {
    resetCurrentMember: () => {
      console.log("resetCurrentMember called");
      return initialCurrentMember;
    },

    assignCurrentMember: (state: any, action) => {
      console.log("assignCurrentMember1:", action.payload);
      return action.payload;
      // state.PersonalAddress = action.payload.Address[0];
      // state.PublishedAddress = action.payload.Address[1];
      // state.MemberSections = action.payload.MemberSections;
      // state.MemberTags = action.payload.MemberTags;
      // console.log("assignCurrentMember2:", state);
      //Joy
    },
    updateCurrentMember: (state: any, action) => {
      console.log("actionpayload:", action.payload);
      console.log("assignCurrentMember1:", state);
      state[action.payload.key] = action.payload.value;
      console.log("assignCurrentMember2:", state);
    },
    SaveSearchString: (state: any, action) => {
      console.log("actionpayload:", action.payload);
      // console.log("SavedSearchString1:", state.SavedSearchString);
      state.SearchId = action.payload;
      console.log("SavedSearchString2:", state.SavedSearchString);
    },
  },
  // extraReducers: (builder) => {
  //   builder.addCase(findMembers.pending, (state: initialMemberListState) => {
  //     state.loading = true;
  //   });
  // },
});

export default currentMemberSlice.reducer;
export const {
  resetCurrentMember,
  assignCurrentMember,
  updateCurrentMember,
  SaveSearchString,
} = currentMemberSlice.actions;
